module.exports = __webpack_public_path__ + "static/media/screens-background.347388d6.png";